import styled, { css } from 'styled-components'

import { up } from '@Globals/Style/breakpoints'
import { flexCenterChildrenColumn, resetButton, transition } from '@Globals/Style/mixins'

export const DialogWrapper = styled.section(({ theme }) => css`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 0 15px 15px;
  width: 100vw;
  max-width: 450px;
  max-height: 100%;

  background-color: ${theme.colors.white};
  /* TODO: Add color to theme */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  pointer-events: auto;
  border-radius: ${theme.borderRadius};

  ${up('phablet')} {
    max-width: 100%;
    width: 450px;
    max-height: 90vh;
  }

  ${up('tablet')} {
    padding: 30px 0 20px 30px;
    max-width: 95vw;
    width: unset;
  }

  .simpleDialog {
    ${flexCenterChildrenColumn};
    padding-top: 30px;

    .title {
      display: block;
      text-align: center;
      font-size: 1.5rem;
      margin-bottom: 10px;
      max-width: 100%;
    }

    .text {
      display: block;
      text-align: center;
      color: ${theme.colors.grey};
      max-width: 100%;
    }
  }

  ${transition}
`)

export const DialogCloseButton = styled.button(({ theme }) => css`
  ${resetButton};
  padding: 13px;
  position: absolute;
  top: -3px;
  right: -3px;
  cursor: pointer;
  transition: all 0.1s ease;
  z-index: 100;

  svg {
    fill: ${theme.colors.greyLight};
  }

  &:hover {
    transform: scale(1.1);
    top: -4px;
    right: -4px;

    svg {
      /* TODO: Add to theme (greyLight darkened 20%) */
      fill: #7e7e7e;
    }
  }

  &:active {
    transform: scale(1);
    top: -3px;
    right: -3px;
  }
`)

export const DialogBody = styled.div<{ hideCloseButton?: boolean, maxWidth?: string }>(({
  hideCloseButton,
  maxWidth,
  theme,
}) => css`
  padding-right: 15px;
  position: relative;
  min-height: 200px;
  min-width: 300px;
  ${maxWidth && `max-width: ${maxWidth};`}
  overflow: auto;
  overflow-x: hidden;
  padding-top: 15px;

  ${up('tablet')} {
    padding-right: ${theme.padding.desktop};
  }

  ${hideCloseButton ? css`padding-top: 10px;` : ''}
  ${transition}
`)

export const DialogFooter = styled.footer(() => css`
  margin-top: 20px;
  margin-right: 30px;
  padding-top: 15px;

  ${up('tablet')} {
    padding-top: 20px;
  }

  button {
    margin-bottom: 0;
  }
`)
